// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_wDlq3","box":"index_box_0pUUi","footer":"index_footer_5tRGC"};